<div class="outer-div">

  <!-- Header -->
  <div class="label-bar">

    <label
      i18n="@@spmsUserReg"
      class="textColour"
      style="font-size: 18px; font-weight: 500">
      Data Mining
    </label>

    <span class="example-spacer"></span>

    <app-common-button
      title="Refresh"
      icon="fas fa-sync-alt"
      [buttonId]="1111"
      [variant]="'cancel'"
      width="100%"
      padding="0rem 1rem"
      fontSize=".85rem"
      height="25px"
      (clicked)="onRefresh()"
      style="margin-left: 6px; margin-right: 6px">
    </app-common-button>

    <app-common-button
      icon="fas fa-download"
      title="Download"
      [buttonId]="1111"
      [variant]="'cancel'"
      width="100%"
      padding="0rem 1rem"
      fontSize=".85rem"
      height="25px"
      (clicked)="onDownload()"
      style="margin-left: 6px; margin-right: 6px">
    </app-common-button>

  </div>


  <!-- Filter Section -->
  <div class=" row filter-section">

    <div
      [formGroup]="filterForm"
      class="col-lg-7 filters-container">


      <!-- Top Controls -->
      <div class="parameter-controls">


        <!-- Dataset -->
        <div class="parameter-group">

          <label class="parameter-label">
            Dataset
          </label>

          <mat-form-field appearance="outline" class="parameter-select">

            <mat-label>Source</mat-label>

            <mat-select formControlName="source">

              <mat-option
                *ngFor="let src of sources"
                [value]="src.code">

                {{ src.name }}

              </mat-option>

            </mat-select>

          </mat-form-field>

        </div>


        <!-- Analysis Type (REFACTORED TO FORMARRAY) -->
        <!-- <div class="parameter-group">

          <label class="parameter-label">
            Analysis Type
          </label>

          <div class="checkbox-group" formArrayName="analysisTypes">

            <mat-checkbox
              *ngFor="let type of analysisTypes; let i = index"
              [formControlName]="i"
              (change)="onAnalysisTypeChange(type)">

              {{ type.label }}

            </mat-checkbox>

          </div>

        </div> -->

      </div>


      <!-- Selection Filters Row -->
      <div class="selection-filters">
          <mat-form-field class="filter-field" appearance="outline">
            <mat-label i18n="@@targetloginusername">
                Products
            </mat-label>
            <mat-select  formControlName="product"
            placeholder="Type product name" [(ngModel)]="selectedProduct">
                    <mat-option *ngFor="let tempObject of productsDisplayed" [value]="tempObject.name">
                        {{tempObject.name}}
                    </mat-option>

            </mat-select>
        </mat-form-field>

        <!-- Product -->
        <!-- <mat-form-field appearance="outline" class="filter-field">

          <mat-label> 
            Product
          </mat-label>

          <input
            matInput
            type="text"
            formControlName="product"
            placeholder="Type product name"
            autocomplete="off" />

          <button
            *ngIf="filterForm.get('product')?.value"
            matSuffix
            mat-icon-button
            (click)="clearProduct($event)">

            <mat-icon>
              close
            </mat-icon>

          </button>

        </mat-form-field> -->


        <!-- Adverse Event -->
        <mat-form-field appearance="outline" class="filter-field">

          <mat-label>
            Adverse Event
          </mat-label>

          <input
            matInput
            type="text"
            formControlName="adverseEvent"
            placeholder="Select adverse event"
            readonly
            (click)="openMedDrabrowser($event)" />

          <button
            *ngIf="filterForm.get('adverseEvent')?.value"
            matSuffix
            mat-icon-button
            (click)="clearAdverseEvent($event)">

            <mat-icon>
              close
            </mat-icon>

          </button>

        </mat-form-field>

        <app-common-button
            label="Add Advanced Filter"
            title="Add Advanced Filter"
            [buttonId]="1111"
            variant="cancel"
            width="120px"
            (clicked)="openAdvancedFilterDialog()">
          </app-common-button>

      </div>


      <!-- Applied Filters Section -->
      <div
        *ngIf="appliedFilters && appliedFilters.length > 0"
        style="margin-top: 10px;">

        <label class="parameter-label">
          Applied Filters
        </label>

        <div style="display:flex; flex-wrap:wrap; gap:8px; margin-top:4px;">

          <div
            *ngFor="let filter of appliedFilters; let i = index"
            style="
                 display: flex;
                  align-items: center;
                  background: var(--gray-200);
                  padding: 1px 8px;
                  border-radius: 6px;
                  font-size: 12px;
                  border: 1px solid var(--surface-500);
            ">

            {{ filter.field }} {{ filter.operator }} {{ filter.value }}

            <mat-icon
              style="font-size: 16px;
                cursor: pointer;
                margin-left: 6px;
                margin-top: 0;
                line-height: unset;
                font-weight: 700;
                width: fit-content;
                height: fit-content;"
              (click)="removeAppliedFilter(i)">
              close
            </mat-icon>

          </div>

        </div>

      </div>
<!-- <ag-grid-angular
  class="ag-theme-alpine custom-grid"
  style="width: 520px; height: 320px;"
  [rowData]="rowData"
  [columnDefs]="TypeColumnDefs"
  [defaultColDef]="typeDefaultColDef"
  [suppressRowTransform]="true">
</ag-grid-angular> -->
 <!-- <ag-grid-angular
        class="ag-theme-balham custom-grid"
         style="width: 520px; height: 315px;"
        [rowData]="rowData"
        [defaultColDef]="typeDefaultColDef"
        [columnDefs]="TypeColumnDefs"
        [suppressRowTransform]="true">

      </ag-grid-angular> -->

      

      <!-- Action Buttons -->
      <div style="display: flex; gap: 10px; margin-top: 20px">

        <app-common-button
          label="Run Analysis"
          title="Run Analysis"
          icon="analytics"
          [buttonId]="1111"
          width="110px"
          (clicked)="runAnalysis()">
        </app-common-button>

        <app-common-button
          *ngIf="filterForm.get('product')?.value || filterForm.get('adverseEvent')?.value"
          label="Clear"
          title="Clear"
          [buttonId]="1111"
          variant="cancel"
          width="110px"
          (clicked)="clearFilters()">
        </app-common-button>

      </div>

    </div>
    <div class="col-lg-5" style="padding: 20px;">
      <ag-grid-angular
        class="ag-theme-balham custom-grid"
        style="width: 520px; height: 335px;"
        [rowData]="rowData"
        [columnDefs]="TypeColumnDefs"
        [defaultColDef]="typeDefaultColDef"
        [rowHeight]="33"
        [headerHeight]="34"
        [domLayout]="'normal'"
         [context]="context"
         (gridReady)="onTypeGridReady($event)"
        [suppressRowTransform]="true">
      </ag-grid-angular>
    </div>

  </div>



  <!-- Analysis Grid -->
  <div class="analysis-grid">

    <div class="grid-header">

      <div class="grid-title">

        <h3>
          Analysis Results
        </h3>

        <span class="result-count">
          {{ analysisData.length }} results
        </span>

      </div>

    </div>


    <div class="grid-container">

      <ag-grid-angular
        style="height: 55vh; width: 100%;"
        class="ag-theme-balham"
        [rowData]="jobList"
        [defaultColDef]="defaultColDef"
        [columnDefs]="jobColumnDefs"
        [gridOptions]="gridOptions"
        [pagination]="true"
        [paginationPageSize]="10"
        [enableBrowserTooltips]="true"
        [components]="components"
        (gridReady)="onGridReady($event)"
        [rowClassRules]="rowClassRules"
        [getRowStyle]="getRowStyle"
        [rowHeight]="35"
      [headerHeight]="35"
      [enableBrowserTooltips]="true"
      [floatingFiltersHeight]="45">

      </ag-grid-angular>

    </div>

  </div>

</div>